<div class="s__step-block">
  @for (step of steps(); track step.number) {
    <div class="s__step-block__step">
      <div class="s__step-block__number-row">
        <div class="s__step-block__number">{{ step.number }}</div>
        <div class="s__step-block__connector" aria-hidden="true"></div>
      </div>
      <h3 class="s__step-block__title">{{ step.title }}</h3>
      <div class="s__step-block__desc" [innerHTML]="step.description"></div>
    </div>
  }
</div>
